import { Checkbox, Modal, Toast } from "@shopify/polaris";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useGetState } from "ahooks";
import intl from "../../../../../i18n/intl";

import BulkEdit from "../../../../../components/NotImportedBulkEdit/BulkEdit";
import { reqPostDropshipmanNewProductAction } from "../../../../../api";
/**
 *
 * @param {*} data
 * data.open 弹窗开关状态
 * data.type 1 导入 2删除 345批量操作collections, tags, product type
 * data.count 选中的数量
 * isBulk 是否批量
 * ids 需要批量的id数组
 *
 */
const OperationModal = ({ data, onChange, importCb ,deleteImportProduct,restoreImportProduct,getTabs,setImportParams,handleSingleImportCb,currTab,setModalParams}) => {
  const { open, type, count, isBulk, ids, all, recordKey,content,isDeleteFromShopify } = data;
  const [active, setActive] = useState(open);
  const [toast, setToast] = useState(false);
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [doneBtnLoading,setDoneBtnLoading] = useState(false)
  const [childData, setChildData, getChildData] = useGetState([]);
  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} duration={2000} onDismiss={toggleToast} error={toastError} />
  ) : null;

  useEffect(() => {
    setActive(open);
    // eslint-disable-next-line
  }, [open]);

  const handleChange = (isDone = false) => {
    
    if ((type !== 'import'&& getChildData().length === 0 && isDone) && ((type !== 'restore' && type !== 'delete') && getChildData().length === 0 && isDone )) {
      return
    }
    setActive(!active);
    onChange(!active);
    isDone && activeModalData.fn();
  };

  // 接收子组件传来的toast提示
  const getChildTip = (val, tipStatus) => {
    setToastError(tipStatus);
    setToastMsg(val);
    setToast(false);
    toggleToast();
  };

  // 接收子组件传来的值
  const getChildOption = (val) => {
    setChildData(val);
  };

  const handleImportProduct = () => {
    const params = { ids: ids,auto_publish:data.checked,is_inventory:data.is_inventory};
    getChildTip(intl.get('Product is listing'), false);
    if (isBulk) {
      importCb(recordKey, {...params,type: all});
    }else{
      handleSingleImportCb(recordKey, params)
    }
  };
  const handleRemoveProduct = () => {
    if (isBulk) {
      deleteImportProduct(recordKey,ids,true)
    }else{
      deleteImportProduct(recordKey,ids)
    }
  };
  const handleRestoreProduct = () => {
    console.log(123,ids,isBulk);
    if (isBulk) {
      restoreImportProduct(recordKey,ids,true)
      
    }else{
      restoreImportProduct(recordKey,ids)
    }
  };

 const handleBulkEdit = async (actionType) => {
  
   try {
  setDoneBtnLoading(true)
    let params = {
      actionType: actionType,
      ids: JSON.stringify(ids),
    };
    if (actionType === 'collection') {
      params = {
        ...params,
        SelectCollectionsOptions:JSON.stringify(getChildData())
      }
    } else if (actionType === 'tags') {
      params = {
        ...params,
        SelectTagsOptions: JSON.stringify(getChildData())
      }
    } else if (actionType === 'productType') {
      params = {
        ...params,
        SelectProductTypeOptions: JSON.stringify(getChildData())
      }
    }
    const response = await reqPostDropshipmanNewProductAction(params)
    if (response.code === '200') {
      onChange(!active);
      getChildTip(intl.get('Saved successfully'), false);
      setDoneBtnLoading(false)
      getTabs()
    } else {
      getChildTip(response.msg,false);
      setDoneBtnLoading(false)
    }
      
   } catch (error) {
    console.log(error,childData);
  }
  }
  const activeModalData = useMemo(() => {
    switch (type) {
      case "import":
        return {
          title: intl.get("List product"),
          content: (
            <p>
              {isBulk
                ? intl.get("Are you sure to list {{count}}  products to your store?",(count === 10 && all ===1) ? count + '+' : count)
                : intl.get(
                    "Are you sure to list this product to your store?"
                  )}
            </p>
          ),
          fn: () => handleImportProduct(),
        };
      case "delete":
        return {
          title: intl.get("Remove product"),
          content: (
            <p>
              {isBulk
                ? (
                  <div>
                  <div>{intl.get("Are you sure to Removed {{count}} products from your product list?",(count === 10 && all ===1) ? count + '+' : count)}</div>
                  {(currTab?.[0] === 'Imported' && <Checkbox
                    label={intl.get("Removed from your Shopify store too.")}
                    checked={isDeleteFromShopify}
                    onChange={(value) => setImportParams((prevValue)=>({
                      ...prevValue,
                      isDeleteFromShopify:value,
                    }))}
                  />)}
                  </div>
                  ) 
                : (
                  <div>
                  <div>{intl.get("Are you sure to Removed this product from your product list?")}</div>
                  {(currTab?.[0] === 'Imported' && <Checkbox
                    label={intl.get("Removed from your Shopify store too.")}
                    checked={isDeleteFromShopify}
                    onChange={(value) => setImportParams((prevValue)=>({
                      ...prevValue,
                      isDeleteFromShopify:value,
                    }))}
                  />)}
                  </div>
                  )}
            </p>
          ),
          fn: () => handleRemoveProduct(),
        };
        case "restore":
          return {
            title: isBulk ? 'Bulk restore products' : 'Restore products',
            content: (
              <div>
                {isBulk
                  ? (
                    <div>Are you sure you want to restore the selected products? Restored products will be displayed in the <strong>Not Listed</strong> list.</div>
                    ) 
                  : (
                    <div>Are you sure you want to restore this product? Restored products will be displayed in the <strong>Not Listed</strong> list.</div>
                    )}
              </div>
            ),
            fn: () => handleRestoreProduct(),
          };
      case "collections":
        return {
          title: intl.get("Bulk edit collections"),
          content: (
            <div className="bulk_edit_collections">
              <BulkEdit
                type={"collections"}
                option={content[0]?.Collections}
                getOption={getChildOption}
              />
            </div>
          ),
          fn: () => handleBulkEdit("collection"),
        };
      case "tags":
        return {
          title: intl.get("Bulk edit tags"),
          content: (
            <div className="bulk_edit_tags">
              <BulkEdit
                type={"tags"}
                getOption={getChildOption}
                showTip={getChildTip}
              />
            </div>
          ),
          fn: () => handleBulkEdit("tags"),
        };
      case "type":
        return {
          title: intl.get("Bulk edit type"),
          content: (
            <div className="bulk_edit_product_type">
              <BulkEdit
                type={"product type"}
                getOption={getChildOption}
                showTip={getChildTip}
              />
            </div>
          ),
          fn: () => handleBulkEdit("productType"),
        };
      default:
        return {
          title: "",
          content: "",
          fn: () => {},
        };
    }
    // eslint-disable-next-line
  }, [data]);

  return (
    <>
      <Modal
        open={active}
        onClose={() => handleChange()}
        title={activeModalData?.title}
        primaryAction={{
          content: intl.get("Done"),
          onAction: () => handleChange(true),
          loading:doneBtnLoading
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () => handleChange(),
          },
        ]}
      >
        <Modal.Section>
          {activeModalData?.content}
         {type === 'import' &&<div style={{marginTop:'16px'}}>
          <Checkbox
          label={intl.get("List as published product")}
          checked={data.checked}
          onChange={()=>{
            setModalParams((prevValue)=>({
              ...prevValue,
              checked:!prevValue.checked,
            }))}
          }
        />
        </div>}
        {type === 'import' &&<div style={{marginTop:'16px'}}>
          <Checkbox
          label={intl.get("Continue selling when products out of stock")}
          checked={data.is_inventory}
          onChange={()=>{
            setModalParams((prevValue)=>({
              ...prevValue,
              is_inventory:!prevValue.is_inventory,
            }))}
          }
        />
        </div>}
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </>
  );
};

export default OperationModal;
